import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  Optional,
  Inject
} from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthenticationService } from '../../../@core/services/authentication.service';
import { DtoShippinpHistory } from '../../../@core/models/dto-shippinghistory';
import { eLivraisonHistorySourceType } from '../../../@core/models/shippinghistorysourcetype';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { DtoModifAddress } from '../../../@core/models/dto-modifaddress';
import { ToastrService } from 'ngx-toastr';
import { LabelService } from '../../../@core/services/label.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-google-address-search',
  templateUrl: './google-address-search.component.html',
  styleUrls: ['./google-address-search.component.scss']
})
export class GoogleAddressSearchComponent implements OnInit {
  latitude: number;
  longitude: number;
  civicnumber: string;
  street: string;
  city: string;
  province: string;
  country: string;
  postalcode: string;
  zoom: number;
  address: string;
  appartment: string;
  aptsuitelocal: string;
  addresstext: string;
  addressformat: string;
  address1: string;
  address2: string;
  note: string;

  oldcity: string;
  oldpostalcode: string;
  oldaddress1: string;
  oldaddress2: string;
  oldnote: string;
  selText: string;

  address1checked: boolean;
  address2checked: boolean;
  shouldShow: boolean;

  private geoCoder;

  @ViewChild('search', { static: true }) searchElementRef: ElementRef;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private authservice: AuthenticationService,
    private apiprovider: ApiProvider,
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<GoogleAddressSearchComponent>,
    private toastservice: ToastrService,
    private labelService: LabelService,
    private translate: TranslateService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.shouldShow = false;
    this.address1checked = false;
    this.address2checked = false;

    if (this.data.Address.Address2) {
      this.addresstext =
        this.data.Address.Address1 + ' ' + this.data.Address.Address2;
    } else {
      this.addresstext = this.data.Address.Address1;
    }

    this.address1 = this.data.Address.Address1;
    this.address2 = this.data.Address.Address2;

    this.oldcity = this.data.Address.City;
    this.oldaddress1 = this.data.Address.Address1;
    this.oldaddress2 = this.data.Address.Address2;
    this.oldpostalcode = this.data.Address.Postal_Code;
    this.postalcode = this.oldpostalcode;
    this.address2 = this.oldaddress2;
    this.address1 = this.oldaddress1;
    this.city = this.oldcity;

    // this.parseAddress();
    //+ ' ' + this.data.Address.Postal_Code
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();

      this.searchElementRef.nativeElement.click();

      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['address'],
          componentRestrictions: { country: 'ca' }
        }
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();

          this.civicnumber = '';
          this.street = '';
          this.city = '';
          this.province = '';
          this.country = '';
          this.postalcode = '';

          for (var j = 0; j < place.address_components.length; j++) {
            if (place.address_components[j].types[0] === 'street_number') {
              this.civicnumber = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'route') {
              this.street = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'locality') {
              this.city = place.address_components[j].long_name;
            }

            if (
              place.address_components[j].types[0] ===
              'administrative_area_level_1'
            ) {
              this.province = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'country') {
              this.country = place.address_components[j].long_name;
            }

            if (place.address_components[j].types[0] === 'postal_code') {
              this.postalcode = place.address_components[j].long_name.replace(
                /\s/g,
                ''
              );
            }
          }

          //this.address1 = this.civicnumber + ' ' + this.street + ', ' + this.city + ', ' + this.province + ' ' + this.country;
          this.address2 = '';

          this.address1 = place.name;
          this.address2 = '';
          this.zoom = 12;
        });
      });
    });
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }

  public markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }

  public addressfocus($event: MouseEvent) { }

  public getAddress(latitude, longitude) {
    this.civicnumber = '';
    this.street = '';
    this.city = '';
    this.province = '';
    this.country = '';
    this.postalcode = '';

    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            this.addresstext = results[0].formatted_address;

            this.ngZone.run(() => {
              //get the place result
              //   let place: google.maps.places.PlaceResult = autocomplete.getPlace();

              //   //verify result
              //   if (place.geometry === undefined || place.geometry === null) {
              //     return;
              //   }

              //   //set latitude, longitude and zoom
              this.latitude = results[0].geometry.location.lat();
              this.longitude = results[0].geometry.location.lng();

              for (var j = 0; j < results[0].address_components.length; j++) {
                if (
                  results[0].address_components[j].types[0] === 'street_number'
                ) {
                  this.civicnumber = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'route') {
                  this.street = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'locality') {
                  this.city = results[0].address_components[j].long_name;
                }

                if (
                  results[0].address_components[j].types[0] ===
                  'administrative_area_level_1'
                ) {
                  this.province = results[0].address_components[j].long_name;
                }

                if (results[0].address_components[j].types[0] === 'country') {
                  this.country = results[0].address_components[j].long_name;
                }

                if (
                  results[0].address_components[j].types[0] === 'postal_code'
                ) {
                  this.postalcode = results[0].address_components[
                    j
                  ].long_name.replace(/\s/g, '');
                }
              }

              this.address1 =
                this.civicnumber +
                ' ' +
                this.street +
                ', ' +
                this.city +
                ', ' +
                this.province +
                ' ' +
                this.country;
              this.address2 = '';
            });
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public save(): void {
    this.shouldShow = true;
    let ModAdress = new DtoModifAddress();
    ModAdress.NewAddress1 = this.address1;
    ModAdress.NewAddress2 = this.address2;
    ModAdress.AccountName = this.data.CustomerName;
    ModAdress.NewPhone = this.data.Lr_Phone;
    ModAdress.NewPostalCode = this.postalcode;
    ModAdress.NewCity = this.city;
    ModAdress.ShippingID =
      this.data.Consol_ID > 0 ? this.data.Consol_ID : this.data.Shipping_ID;
    ModAdress.NewAccountName = this.data.CustomerName;

    ModAdress.OldAccountName = this.data.CustomerName;
    ModAdress.OldAddress1 = this.oldaddress1;
    ModAdress.OldAddress2 = this.oldaddress2;
    ModAdress.OldPostalCode = this.oldpostalcode;
    ModAdress.OldCity = this.oldcity;
    ModAdress.OldPhone = this.data.Lr_Phone;
    ModAdress.userID = this.authservice.currentUserValue.UserID;

    ModAdress.Latitude = this.latitude;
    ModAdress.Longitude = this.longitude;

    let shippinghistory: DtoShippinpHistory = new DtoShippinpHistory();
    shippinghistory.ShippingID = ModAdress.ShippingID;

    // if (ispickuplivraison) {
    //   lh.ShippingID = DALShipping.GetPULIVID(lh.ShippingID);
    // }

    shippinghistory.CustomerID = this.data.CustomerID;
    shippinghistory.ProcessedDate = new Date();
    shippinghistory.ExceptionCode = 32;
    shippinghistory.SourceType = eLivraisonHistorySourceType.TPSLRoute;
    shippinghistory.UserID = this.authservice.currentUserValue.UserID;

    // Call API Endpoint To Insert code 32

    this.apiprovider
      .InsertAddressChangeCode32(ModAdress)
      .subscribe((result) => {
        this.shouldShow = false;
        if (result === 0) {
          this.toastservice.success(
            'Changement addresse',
            'Changement addresse effectué',
            {
              positionClass: 'toast-bottom-left',
              disableTimeOut: false,
              enableHtml: true
            }
          );
          this.dialogRef.close(true);
        } else if (result === 1) {
          // suspended shipment code 33
        } else if (result === 2) {
          // cancelled shipment
        } else {
          this.toastservice.error(
            'Erreur de changement addresse',
            'Changement addresse annule',
            {
              positionClass: 'toast-bottom-left',
              disableTimeOut: false,
              enableHtml: true
            }
          );
        }
      });

    //  this.dialogRef.close(false);
  }

  public onClickParseAddress() {
    this.parseAddress();
  }

  public Search(address1checked) {
    this.ngZone.run(() => {
      this.addresstext = '';
      // if (this.data.Address.Address2) {
      //   this.addresstext = this.data.Address.Address1 + ' ' + this.data.Address.Address2;
      // }
      // else {
      //   this.addresstext = this.data.Address.Address1;
      // }

      if (this.address1checked) {
        this.addresstext += ' ' + this.address1;
      }

      this.searchElementRef.nativeElement.focus();
      this.searchElementRef.nativeElement.click();
    });
  }
  public parseAddress() {
    let civicnumberlkup = /^^([a-z0-9].*?[\.\/\,]?[a-z0-9]?)\s(Av?E?N?U?E?|chemin|pla?c?e?|che?m?i?n?|route|rang|boulevard|bd|blvd|bvld?|boul|rue|montee)(?:\s?\.?\,?)+(.*)/i.exec(
      this.data.Address.Address1
    );
    // let appartementlkup = /(?=app|apt|appt|appart|appartement|#)(app|apt|appt|appart|appartement|#)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(this.data.Address.Address1);
    let appartementlkup = /(floor(?!.*floor)|local(?!.*local)|unit(?!.*unit)|suite(?!.*suite))(.*)/i.exec(
      this.data.Address.Address1
    );
    let suitelkup = /^(.*?)(suite(?!.*suite)|suite\s?#(?!.*suite\s?#)|suite\s?:(?!.*suite\s?:)|suit(?!.*suit)|#(?!.*#))\s*,*\.*\s?\s*([a-z0-9]+[-]*[a-z0-9]*)(.*)/i.exec(
      this.addresstext
    );
    let bureaulkup = /(?=bur|bureau)(bur|bureau)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
      this.data.Address.Address1
    );
    let floorlkup = /(etage)\s\d+|(((?:1i?er|1\s?i?ere?|premier|\d+(?:\s*)e?i?e?è?m?e?|\d+(?:\s*)er|\d+(?:\s*)?ii?e?è?me|\d+(?:\s*)?iemes|\d+(?:\s*)?e?è?me|\d+(?:\s*)?ie?è?me?|\d+(?:\s*)?e|\d\d(?:\s*)?e|\d\d?(?:\s*)?th|main(?:\s*)?|first(?:\s*)?|1st(?:\s*)?|second(?:\s*)?|\dnd(?:\s*)?|third(?:\s*)?|3rd(?:\s*)?|fourth(?:\s*)?|fifth(?:\s*)?|sixth(?:\s*)?|seventh(?:\s*)?|eighth(?:\s*)?|nineth(?:\s*)?|tenth(?:\s*)?))(?:[\s\.\:\-\,]*)(fl\.|flo?o?r?|e?é?tage))(.*)|é?e?tage\s#?\d+/i.exec(
      this.data.Address.Address1
    );

    // this.addresstext

    if (civicnumberlkup) {
      this.civicnumber = civicnumberlkup[1];
    } else {
      civicnumberlkup = /^([a-z0-9-\/\.?]*)(,|\s)(.*)/i.exec(
        this.data.Address.Address2
      );
    }

    if (appartementlkup) {
      this.aptsuitelocal = appartementlkup[0];
      this.addresstext = this.addresstext.replace(appartementlkup[0], '');
    } else {
      appartementlkup = /(?=app|apt|appt|appart|appartement|#)(app|apt|appt|appart|appartement|#)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
        this.data.Address.Address2
      );
      if (appartementlkup) {
        this.aptsuitelocal = appartementlkup[0];
        this.addressformat = this.data.Address.Address2.replace(
          appartementlkup[0],
          ''
        );
      }
    }

    if (floorlkup) {
      this.aptsuitelocal = floorlkup[0];
      this.addressformat = this.data.Address.Address1.replace(floorlkup[0], '');
    } else {
      floorlkup = /(etage)\s\d+|(((?:1i?er|1\s?i?ere?|premier|\d+(?:\s*)e?i?e?è?m?e?|\d+(?:\s*)er|\d+(?:\s*)?ii?e?è?me|\d+(?:\s*)?iemes|\d+(?:\s*)?e?è?me|\d+(?:\s*)?ie?è?me?|\d+(?:\s*)?e|\d\d(?:\s*)?e|\d\d?(?:\s*)?th|main(?:\s*)?|first(?:\s*)?|1st(?:\s*)?|second(?:\s*)?|\dnd(?:\s*)?|third(?:\s*)?|3rd(?:\s*)?|fourth(?:\s*)?|fifth(?:\s*)?|sixth(?:\s*)?|seventh(?:\s*)?|eighth(?:\s*)?|nineth(?:\s*)?|tenth(?:\s*)?))(?:[\s\.\:\-\,]*)(fl\.|flo?o?r?|e?é?tage))(.*)|é?e?tage\s#?\d+/i.exec(
        this.data.Address.Address2
      );
      if (floorlkup) {
        this.aptsuitelocal = floorlkup[0];
        this.addressformat =
          this.data.Address.Address1 +
          ' ' +
          this.data.Address.Address2.replace(floorlkup[0], '');
      }
    }

    if (suitelkup) {
      this.aptsuitelocal = suitelkup[0];
      this.addressformat = this.data.Address.Address1.replace(suitelkup[0], '');
    } else {
      suitelkup = /^(.*?)(suite(?!.*suite)|suite\s?#(?!.*suite\s?#)|suite\s?:(?!.*suite\s?:)|suit(?!.*suit)|#(?!.*#))\s*,*\.*\s?\s*([a-z0-9]+[-]*[a-z0-9]*)(.*)/i.exec(
        this.data.Address.Address2
      );
      if (suitelkup) {
        this.aptsuitelocal = suitelkup[0];
        this.addressformat =
          this.data.Address.Address1 +
          ' ' +
          this.data.Address.Address2.replace(suitelkup[0], '');
        this.addresstext = this.addresstext.replace(suitelkup[0], '');
      }
    }

    if (bureaulkup) {
      this.aptsuitelocal = bureaulkup[0];
      this.addressformat = this.data.Address.Address1.replace(
        bureaulkup[0],
        ''
      );
    } else {
      bureaulkup = /(?=bur|bureau)(bur|bureau)\s*([#\.,:]?[\s\.]+([^\s]+)|[#\.,]?\d+([^\s]+)|[\:\#,]+\d+|\d+|[#-\/]([^\s]+))/i.exec(
        this.data.Address.Address2
      );
      if (bureaulkup) {
        this.addressformat = this.data.Address.Address2.replace(
          bureaulkup[0],
          ''
        );
      }
    }
  }
  public OnSelectInput() {
    var text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();
    } else if (
      document.getSelection() &&
      document.getSelection().type != 'Control'
    ) {
    }
    this.selText = text;
  }

  //  public GetSelectedText () {
  //     var selText = "";
  //     if (window.getSelection) {  // all browsers, except IE before version 9
  //         if ( this.searchElementRef.nativeElement &&
  //                 ( this.searchElementRef.nativeElement.tagName.toLowerCase () == "textarea" ||
  //                 this.searchElementRef.nativeElement.tagName.toLowerCase () == "input"))
  //         {
  //             var text =  this.searchElementRef.nativeElement.value;
  //             selText = text.substring ( this.searchElementRef.nativeElement.selectionStart,
  //               this.searchElementRef.nativeElement.selectionEnd);
  //         }
  //         else {
  //             var selRange = window.getSelection ();
  //             selText = selRange.toString ();
  //         }
  //     }
  //     else {
  //         // if (document.selection.createRange) {       // Internet Explorer
  //         //     var range = document.selection.createRange ();
  //         //     selText = range.text;
  //         // }
  //     }
  //     return selText;
  // }
}
